<template>
  <van-tabbar route fixed active-color="#ff6600" class="app-footer">
    <van-tabbar-item
      replace
      to="/"
      icon="home-o"
    >
      首页
    </van-tabbar-item>
    <van-tabbar-item
      replace
      :to="`/register?zsls=${zslsinfo?.id ?? ''}`"
      icon="notes-o"
    >
      立即报名
    </van-tabbar-item>
    <van-tabbar-item
      replace
      to="/stu-list"
      icon="user-circle-o"
    >
      我的
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AppFooter',
  props: [],
  computed: {
    ...mapGetters({
      zslsinfo: 'zslsinfo',
    }),
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.app-footer.van-tabbar {
  .fixedapp();
}
.app-footer /deep/ .van-tabbar-item {
  .fontsize(.9rem);
  .van-tabbar-item__icon {
    .fontsize(1.4rem);
  }
}
</style>